import { createFionaClient } from '../templates/ClientFactory'
import { DebtConsolidationControllerApi } from 'generated/api/apis/DebtConsolidationControllerApi'
import { ApprovabilityControllerApi } from 'generated/api/apis/ApprovabilityControllerApi'

const calculatorClient = () => {
	const debtConsolidationClient = new DebtConsolidationControllerApi()
	const approvabilityClient = new ApprovabilityControllerApi()
	return {
		getCalculationResult: createFionaClient(
			debtConsolidationClient.debtConsolidationControllerGetDebtConsolidationCalculationResult.bind(
				debtConsolidationClient
			)
		),
		getApprovability: createFionaClient(
			approvabilityClient.approvabilityControllerApprovability.bind(approvabilityClient)
		)
	}
}

type CalculatorClient = ReturnType<typeof calculatorClient>
let calculatorClientInstance: CalculatorClient
export const getCalculatorClient = (rebuild = false) => {
	if (rebuild || !calculatorClientInstance) {
		calculatorClientInstance = calculatorClient()
	}
	return calculatorClientInstance
}
